import React from 'react'
import { observer, inject } from 'mobx-react'

import CloseIcon from '../common/icons/CloseIcon'
import { formatNumber } from '../../utils'

const QuickFilter = ({ name, label, filter, uiStore }) => {
  if (filter.isAtDefault || filter.disabled) return null

  const handleQuickReset = () => {
    if (!uiStore.filters[name]) return

    uiStore.filters[name].reset()

    if (!uiStore.filters.isAtDefaults || uiStore.filters.searchQuery) {
      uiStore.applyFilters()
    } else {
      uiStore.clearFilters()
    }
  }

  return (
    <div className='quick-filter'>
      {label} [{formatNumber(filter.min)} - {formatNumber(filter.max)}]
      <CloseIcon onClick={handleQuickReset} />
    </div>
  )
}

export const TypeQuickFilter = inject('uiStore')(observer(({ uiStore }) => {
  if (uiStore.filters.isTypeAtDefault) return null

  const handleQuickReset = () => {
    uiStore.filters.resetType()

    if (!uiStore.filters.isAtDefaults || uiStore.filters.searchQuery) {
      uiStore.applyFilters()
    } else {
      uiStore.clearFilters()
    }
  }

  return (
    <div className='quick-filter'>
      T [{uiStore.filters.typeValue}]
      <CloseIcon onClick={handleQuickReset} />
    </div>
  )
}))

export const StatusQuickFilter = inject('uiStore')(observer(({ uiStore }) => {
  if (uiStore.filters.isStatusAtDefault) return null

  const handleQuickReset = () => {
    uiStore.filters.resetStatus()

    if (!uiStore.filters.isAtDefaults || uiStore.filters.searchQuery) {
      uiStore.applyFilters()
    } else {
      uiStore.clearFilters()
    }
  }

  return (
    <div className='quick-filter'>
      S [{uiStore.filters.statusValue}]
      <CloseIcon onClick={handleQuickReset} />
    </div>
  )
}))

export const TagQuickFilter = inject('uiStore')(observer(({ uiStore }) => {
  if (uiStore.filters.isTagsAtDefault) return null

  const handleQuickReset = () => {
    uiStore.filters.resetTags()

    if (!uiStore.filters.isAtDefaults || uiStore.filters.searchQuery) {
      uiStore.applyFilters()
    } else {
      uiStore.clearFilters()
    }
  }

  return (
    <div className='quick-filter'>
      Tags [{uiStore.filters.tags.map(tag => tag.label).join(', ')}]
      <CloseIcon onClick={handleQuickReset} />
    </div>
  )
}))

export default inject('uiStore')(observer(QuickFilter))
